export const pirTemplateAdf = {
	version: 1,
	type: 'doc',
	content: [
		{
			type: 'heading',
			attrs: {
				level: 5,
			},
			content: [
				{
					type: 'text',
					text: 'Incident summary',
				},
				{
					type: 'hardBreak',
				},
				{
					type: 'hardBreak',
				},
				{
					type: 'text',
					text: 'Leadup',
				},
			],
		},
		{
			type: 'paragraph',
			content: [
				{
					type: 'text',
					text: 'Describe the circumstances that led to this incident.',
					marks: [
						{
							type: 'textColor',
							attrs: {
								color: '#97a0af',
							},
						},
					],
				},
			],
		},
		{
			type: 'heading',
			attrs: {
				level: 5,
			},
			content: [
				{
					type: 'text',
					text: 'Fault',
				},
			],
		},
		{
			type: 'paragraph',
			content: [
				{
					type: 'text',
					text: 'Describe what failed to work as expected.',
					marks: [
						{
							type: 'textColor',
							attrs: {
								color: '#97a0af',
							},
						},
					],
				},
			],
		},
		{
			type: 'heading',
			attrs: {
				level: 5,
			},
			content: [
				{
					type: 'text',
					text: 'Root cause',
				},
			],
		},
		{
			type: 'paragraph',
			content: [
				{
					type: 'text',
					text: 'Run a 5-whys analysis to understand the true cause of the incident.',
					marks: [
						{
							type: 'textColor',
							attrs: {
								color: '#97a0af',
							},
						},
					],
				},
			],
		},
		{
			type: 'heading',
			attrs: {
				level: 5,
			},
			content: [
				{
					type: 'text',
					text: 'Mitigation and resolution',
				},
			],
		},
		{
			type: 'paragraph',
			content: [
				{
					type: 'text',
					text: 'What steps did you take to resolve the incident?',
					marks: [
						{
							type: 'textColor',
							attrs: {
								color: '#97a0af',
							},
						},
					],
				},
			],
		},
		{
			type: 'heading',
			attrs: {
				level: 5,
			},
			content: [
				{
					type: 'text',
					text: 'Lessons learned',
				},
			],
		},
		{
			type: 'paragraph',
			content: [
				{
					type: 'text',
					text: 'What went well? What could have gone better? What else did you learn?',
					marks: [
						{
							type: 'textColor',
							attrs: {
								color: '#97a0af',
							},
						},
					],
				},
			],
		},
	],
} as const;
